/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import configureStore from '../Configs/store';
import rootSaga from '../Sagas';
import persist from '../Configs/persist';
import StartupRedux from './StartupRedux';
import AdsRedux from './AdsRedux';
import NewsRedux from './NewsRedux';
import ArticlesReducer from './Reducer/ArticleReducer';
// import PrefRedux from './PrefRedux';

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  app: StartupRedux,
  articles: ArticlesReducer,
  ads: AdsRedux,
  news: NewsRedux,
});

export default () => {
  let finalReducers = reducers;
  // If rehydration is on use persistReducer otherwise default combineReducers
  if (persist.active) {
    const persistConfig = persist.storeConfig;
    finalReducers = persistReducer(persistConfig, reducers);
  }

  let { store, sagaMiddleware, sagasManager } = configureStore(
    finalReducers,
    rootSaga
  );

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = reducers;
      store.replaceReducer(nextRootReducer);

      sagasManager.cancel();
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware(rootSaga);
      });
    });
  }

  return store;
};
